import React from 'react';
import { CheckIcon } from 'lucide-react';
import { mapIncludes, modules, systemCopy } from '../data/content';
export function WhatYouGet() {
  return <section id="contenido" className="w-full bg-blue-50 py-14 md:py-20" data-id="element-273" data-mp="zyiyhb4ebuly">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-274" data-mp="l4mqxeg2f5zs">
        <header className="mx-auto max-w-3xl text-center" data-id="element-275" data-mp="q1wespnt39li">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-276" data-mp="q4imqqelzr49">
            {systemCopy.title}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-blue-900/70 md:text-xl" data-id="element-277" data-mp="1ird4vgnyeeek">
            {systemCopy.subtitle}
          </p>
        </header>

        <ul className="mx-auto mt-10 grid max-w-4xl gap-5 md:grid-cols-3" data-id="element-278" data-mp="1404j5in69d6p">
          {modules.map(module => <li key={module.number} className="flex h-full flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-blue-100" data-id="element-279" data-mp="1wquxk74debt7">
              <span className={`h-1.5 w-12 rounded-full ${module.spine}`} aria-hidden="true" data-id="element-280" data-mp="21iw55fqlfecw" />
              <p className="mt-5 text-xs font-extrabold uppercase tracking-widest text-blue-900/50" data-id="element-281" data-mp="2vgc4rpregq2l">
                {systemCopy.areaLabel} {module.number}
              </p>
              <h3 className="mt-1 text-xl font-extrabold tracking-tight text-slate-900" data-id="element-282" data-mp="356ourxhzhbg4">
                {module.title}
              </h3>
              <p className="mt-1 text-sm font-extrabold uppercase tracking-wider text-blue-600" data-id="element-283" data-mp="30cu2i5obbo5f">
                {module.detail}
              </p>
              <p className="mt-4 font-semibold text-slate-900" data-id="element-284" data-mp="3980c7fqpeqd8">{module.summary}</p>
              <p className="mt-2 text-blue-900/75" data-id="element-285" data-mp="3o47ugaijxhpv">{module.description}</p>
            </li>)}
        </ul>

        <div className="mx-auto mt-6 max-w-4xl rounded-2xl bg-white p-6 shadow-sm ring-1 ring-blue-100 md:p-8" data-id="element-286" data-mp="3j550pm80uxx7">
          <h3 className="text-lg font-extrabold tracking-tight text-blue-600 md:text-xl" data-id="element-287" data-mp="1tri0jss6o8ih">
            {systemCopy.includesTitle}
          </h3>
          <ul className="mt-5 grid gap-4 sm:grid-cols-2" data-id="element-288" data-mp="1otqa7376suge">
            {mapIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-289" data-mp="2ehvro68vykwt">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-600" data-id="element-290" data-mp="2ihmnwph6lt8q">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-291" data-mp="2nik1eor8xz3w" />
                </span>
                <span className="text-slate-900" data-id="element-292" data-mp="2scxswg2sfm3a">{item}</span>
              </li>)}
          </ul>
        </div>

        <p className="mx-auto mt-10 max-w-3xl text-center text-2xl font-extrabold italic leading-snug tracking-tight text-blue-600 md:text-3xl" data-id="element-293" data-mp="31fqmwr3cubwt">
          {systemCopy.closing}
        </p>
      </div>
    </section>;
}